/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {Action as ɵb} from './lib/actions/decorators/action';
export {UpdateOnChangeDirective as ɵa} from './lib/directives/update-on-change.directive';